import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { pdfjs } from 'react-pdf';
import App from './App';
import HomePage from './pages/HomePage';
import JobsPage from './pages/JobsPage';
import LoginPage from './pages/LoginPage';
import VerifyLinkPage from './pages/VerifyLinkPage';
import SchedulePage from './pages/SchedulePage';
import AccountSettingsPage from './pages/AccountSettingsPage';
import HelpPage from './pages/HelpPage';
import ResourcesPage from './pages/ResourcesPage';
import MaintenanceWrapper from './MaintenanceWrapper';
import { AuthProvider } from './context/AuthContext';
import theme from './theme';
import './styles.css'; // Keep this for any custom styles not covered by MUI
import './pdf-styles.css'; // Custom styles for PDF viewer

// Initialize PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* Provides a consistent CSS baseline */}
      <AuthProvider>
        <BrowserRouter>
          <MaintenanceWrapper>
            <Routes>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="/home" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/verify" element={<VerifyLinkPage />} />
              <Route path="/help" element={<HelpPage />} />
              <Route path="/jobs" element={<JobsPage />} />
              <Route path="/schedule" element={<SchedulePage />} />
              <Route path="/account-settings" element={<AccountSettingsPage />} />
              <Route path="/resources" element={<ResourcesPage />} />
              <Route path="/worksheet/:token" element={<App />} />
              <Route path="/worksheet/job/:jobNumber" element={<App authenticatedFlow={true} />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </MaintenanceWrapper>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);